import { Link } from "react-router-dom";
import VideoCard from "@/components/feature/VideoCard";
import type { VideoItem } from "@/mocks/videos";

interface VideoSectionProps {
  title: string;
  subtitle: string;
  icon: string;
  videos: VideoItem[];
  linkTo?: string;
  linkLabel?: string;
}

export default function VideoSection({
  title,
  subtitle,
  icon,
  videos,
  linkTo,
  linkLabel = "查看全部",
}: VideoSectionProps) {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 md:px-6 pt-10 md:pt-14">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
            <i className={`${icon} text-lg`} />
          </span>
          <div>
            <h2 className="font-heading text-lg md:text-2xl font-bold text-foreground-950">
              {title}
            </h2>
            <p className="text-xs md:text-sm text-foreground-600">{subtitle}</p>
          </div>
        </div>
        {linkTo && (
          <Link
            to={linkTo}
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
          >
            {linkLabel}
            <i className="ri-arrow-right-s-line" />
          </Link>
        )}
      </div>

      <div className="mt-5 md:mt-6 grid grid-cols-2 gap-3 md:gap-5 sm:grid-cols-3 lg:grid-cols-4">
        {videos.map((video, index) => (
          <VideoCard key={video.id} video={video} index={index} />
        ))}
      </div>
    </section>
  );
}